import {
	Component, Input, Output, EventEmitter, OnInit, OnDestroy,
	OnChanges, SimpleChange, SimpleChanges
} from '@angular/core';
import { LicenseInfoDto, LicenseWizardRequestDto, LicenseWizardResultDto } from 'UvExplorerServer.Dtos.TS/LicenseStats';
import { LicensingService } from '../../services/licensing.service';
import { MessageService } from 'base';

@Component({
    selector: 'deactivation-wizard',
	templateUrl: './deactivation-wizard.component.html',
	styleUrls: ['./deactivation-wizard.component.scss']

})
export class DeactivationWizardComponent implements OnInit, OnDestroy, OnChanges {

	@Input()
	public visible: boolean;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onOk: EventEmitter<any>;

	@Output()
	public onCancel: EventEmitter<any>;

	public backLabel: string;
	public nextLabel: string;
	public cancelLabel: string;

	public readonly WelcomePage = "welcome";
	public readonly OnlinePage = "online";
	public readonly OnlineFailedPage = "online-failed";
	public readonly OfflineQueryPage = "offline-query";
	public readonly OfflinePage = "offline";
	public readonly CompletionPage = "completion";

	public page: string;
	private deactivationRequest: string;
	private savedDeactivationRequest: boolean;

	public onlineFailedLabel: string;

	private ok: boolean;

	constructor(private licService: LicensingService,
		private messageService: MessageService) {

		this.visible = false;
		this.visibleChange = new EventEmitter<boolean>();
		this.onOk = new EventEmitter<any>();
		this.onCancel = new EventEmitter<any>();
	}

	private resetDialog(): void {
		this.backLabel = "< Back";
		this.nextLabel = "Next >";
		this.cancelLabel = "Cancel";

		this.page = "";
		this.deactivationRequest = "";
		this.savedDeactivationRequest = false;

		this.ok = false;

		this.resetOnlineFailedLabel();

		this.setPage(this.WelcomePage);

		this.updateIsActivated();
	}

	public get isActivated() {
		return this.licService.isActivated;
	}

	private resetOnlineFailedLabel(): void {
		this.onlineFailedLabel = "License deactivation failed.";
	}

	public ngOnInit(): void {
		//this.resetDialog();
	}

	public ngOnDestroy(): void {
	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;

		change = changes["visible"];
		if (change) {
			if (this.visible) {
				this.resetDialog();
			}
		}
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);
	}

	private updateIsActivated(): void {
		this.licService.getLicenseInfo().subscribe(
			(result: LicenseInfoDto) => {
				// do nothing
			},
			(error) => {
				this.messageService.displayErrorMessage("Error getting activation status");
			});		
	}

	private setPage(newPage: string): void {

		this.page = newPage;

		if (this.page === this.OnlinePage ||
			this.page === this.OfflineQueryPage) {

			this.nextLabel = "Deactivate >";
		}
		else if (this.page === this.CompletionPage) {
			this.nextLabel = "Finish";
		}
		else {
			this.nextLabel = "Next >";
		}

		if (this.page === this.OfflinePage) {
			console.assert(this.isActivated);
			let request = new LicenseWizardRequestDto("start-offline-page");
			this.deactivationRequest = "";
			this.savedDeactivationRequest = false;
			this.messageService.startWork();
			this.licService.licenseDeactivationWizard(request).subscribe(
				(result: LicenseWizardResultDto) => {
					this.messageService.endWork();
					if (result.succeeded) {
						this.deactivationRequest = result.deactivationRequest;
					}
					else {
						this.messageService.displayErrorMessage(result.errorMessage);
					}
				},
				(error) => {
					this.messageService.endWork();
					this.messageService.displayErrorMessage("Error starting offline deactivation");
					this.setPage(this.OfflineQueryPage);
				});
		}
	}

	public onSaveDeactivationRequest(): void {
		if (!!this.deactivationRequest) {
			this.download(this.deactivationRequest, "deactivation-request.xml", "text/plain");
			this.savedDeactivationRequest = true;
		}
		else {
			this.messageService.displayErrorMessage("Deactivation request is empty");
		}
	}

	// Function to download data to a file
	private download(data, filename, type): void {
		var file;
		if (data instanceof Blob) {
			file = data;
		}
		else {
			file = new Blob([data], { type: type });
		}
		var a = document.createElement("a"),
			url = URL.createObjectURL(file);
		a.href = url;
		a.download = filename;
		document.body.appendChild(a);
		a.click();
		setTimeout(function () {
			document.body.removeChild(a);
			window.URL.revokeObjectURL(url);
		}, 0);
	}

	public get enableBack(): boolean {
		if (this.page === this.WelcomePage) {
			return false;
		}
		else if (this.page === this.OnlinePage) {
			return true;
		}
		else if (this.page === this.OnlineFailedPage) {
			return true;
		}
		else if (this.page === this.OfflineQueryPage) {
			return true;
		}
		else if (this.page === this.OfflinePage) {
			return false;
		}
		else if (this.page === this.CompletionPage) {
			return false;
		}
		else {
			return false;
		}
	}

	public get enableNext(): boolean {
		if (this.page === this.WelcomePage) {
			return true;
		}
		else if (this.page === this.OnlinePage) {
			return this.isActivated;
		}
		else if (this.page === this.OnlineFailedPage) {
			return false;
		}
		else if (this.page === this.OfflineQueryPage) {
			return true;
		}
		else if (this.page === this.OfflinePage) {
			return this.savedDeactivationRequest;
		}
		else if (this.page === this.CompletionPage) {
			return true;
		}
		else {
			return false;
		}
	}

	public get enableCancel(): boolean {
		return (this.page !== this.CompletionPage);
	}

	public onDialogHide(): void {
		this.hide();
		if (this.ok) {
			this.onOk.emit();
		}
		else {
			this.onCancel.emit();
		}	}

	public onCancelClicked(): void {
		this.hide();
	}

	public onNextClicked(): void {

		if (this.page === this.WelcomePage) {
			this.setPage(this.OnlinePage);
		}
		else if (this.page === this.OnlinePage) {
			console.assert(this.isActivated);
			let request = new LicenseWizardRequestDto("next-online-page");
			this.resetOnlineFailedLabel();
			this.messageService.startWork();
			this.licService.licenseDeactivationWizard(request).subscribe(
				(result: LicenseWizardResultDto) => {
					this.messageService.endWork();
					if (result.nextPage === this.OnlineFailedPage) {
						this.onlineFailedLabel = result.errorMessage;
					}
					this.setPage(result.nextPage);
				},
				(error) => {
					this.messageService.endWork();
					this.messageService.displayErrorMessage("Error deactivating license");
				});
		}
		else if (this.page === this.OfflineQueryPage) {
			this.setPage(this.OfflinePage);
		}
		else if (this.page === this.OfflinePage) {
			console.assert(!!this.deactivationRequest);
			console.assert(this.savedDeactivationRequest);
			this.setPage(this.CompletionPage);
		}
		else if (this.page === this.CompletionPage) {
			this.hide();
		}
	}

	public onBackClicked(): void {

		if (this.page === this.OnlinePage) {
			this.setPage(this.WelcomePage);
		}
		if (this.page === this.OnlineFailedPage) {
			this.setPage(this.OnlinePage);
		}
		else if (this.page === this.OfflineQueryPage) {
			this.setPage(this.OnlinePage);
		}
	}

}